<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <div style="position: absolute;top:10px;right:20px;z-index: 99">
        <div>
          <el-checkbox v-model="checked" style="padding-left:16px;">每60秒刷新当前页面</el-checkbox>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in dealPaymentApplicationList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <finance-seach
        ref="financeSeachRefs"
        :column-option="columnList"
        :expression-array="['badCount']"
        :timer-array="['processDate','createDate']"
        @onSearch="onSearch"
      >
        <div class="search_rightitem" v-show="activeName === '1'">
          <el-button
            type="primary"
            :disabled="!list.some(ele=>ele.extract===1)"
            @click="onClaims"
          >批量领取</el-button>
        </div>
      </finance-seach>
      <div class="box-table" :style="{height: $store.state.Sell.height+'px'}">
        <el-table
          border
          ref="tableRef"
          :data="list"
          :max-height="$store.state.Sell.height"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            key="1"
            fixed
            type="selection"
            :selectable="selectableFun"
            width="35"
            v-if="activeName==='1'"
          ></el-table-column>
          <el-table-column label="坏账申请编号" prop="badNumber" width="150" show-overflow-tooltip key="2"></el-table-column>
          <el-table-column label="合同编号" width="150" key="3">
            <template slot-scope="scope">
              <span
                class="approval"
                @click="onContract(scope.row)"
              >{{scope.row.orderContractNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" prop="cusName" min-width="85" show-overflow-tooltip key="4"></el-table-column>
          <el-table-column label="付款类型" width="80" key="5">
            <template slot-scope="scope">{{ scope.row.payType | payTypeFilters }}</template>
          </el-table-column>
          <el-table-column label="合同金额" width="100" key="6">
            <template slot-scope="scope">{{ scope.row.contractTotal | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="应收金额" width="85" key="7">
            <template slot-scope="scope">{{ scope.row.accountsCollect | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="已收金额" width="85" key="8">
            <template slot-scope="scope">{{ scope.row.accountsReceived | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="坏账金额" width="85" key="9">
            <template slot-scope="scope">{{ scope.row.badCount | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="提成扣除" width="85" key="10">
            <template slot-scope="scope">{{ scope.row.commissionDeduction | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="公司承担" width="85" key="11">
            <template slot-scope="scope">{{ scope.row.companyCommitment | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="申请人" prop="createUser" width="85" key="12"></el-table-column>
          <el-table-column label="所属部门" prop="orgName" width="100" show-overflow-tooltip key="13"></el-table-column>
          <el-table-column label="申请时间" width="132px" key="14">
            <template slot-scope="scope">{{ scope.row.createDate | dateFilterL }}</template>
          </el-table-column>
          <el-table-column label="认领人" prop="processUser" width="85" v-if="activeName==='1'" key="15"></el-table-column>
          <el-table-column :label="activeName==='3'?'处理时间':'认领时间'" width="132px" key="16">
            <template slot-scope="scope">{{ scope.row.processDate | dateFilterL }}</template>
          </el-table-column>
          <el-table-column label="操作" width="85" fixed="right" key="17">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="(scope.row.extract===1||scope.row.extract===3)&&activeName==='1'"
                @click="onClaim(scope.row,scope.row.extract)"
              >{{scope.row.extract===1?'认领':'提取'}}</el-button>
              <el-button
                type="text"
                v-if="scope.row.extract===2||activeName==='3'"
                @click="onExtract(scope.row)"
              >{{activeName==='3'?'查看':'处理'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import {
  dealPaymentApplicationList,
  badDebte
} from '../financeManage/util/data'
import {
  queryFinanceBadDebtListByState,
  financeBadDebtA
} from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'

export default {
  components: { pagination, financeSeach },
  data () {
    return {
      columnArr: [],
      columnList: [], // 搜索列表
      dealPaymentApplicationList,
      activeName: '1', // tabs选中状态
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      listArr: [
        'updateStateByFbdIdsClaim',
        'updateStateByFbdIdsClaimAll',
        'updateStateByFbdIds'
      ],
      loadingTable: false, // 列表loading
      checked: false,
      fbdIds: [],
      checkList: []
    }
  },
  mounted () {
    this.activeName = this.$route.query.actName || '1'
    this.getList()
    this.columnList = [
      ...badDebte,
      { label: '认领人', value: 'processUser' },
      { label: '认领时间', value: 'processDate' }
    ]
  },
  updated () {
    // 每60秒刷新一次页面
    if (this.checked === true) {
      setTimeout(() => {
        this.getList()
      }, 60000)
    }
  },
  methods: {
    selectableFun (row) {
      return row.extract === 1
    },
    onContract (row) {
      this.$router.push({
        name: 'contractEdit',
        query: {
          id: row.obId,
          cusId: row.cusId
        }
      })
    },
    // 认领
    onClaim (row, num) {
      this.fbdIds = [row.id]
      this.onBatch(num)
    },
    onClaims () {
      this.fbdIds = this.checkList.map((ele) => {
        return ele.id
      })
      this.onBatch(2)
    },
    onBatch (num) {
      // 1 认领 2 批量认领 3 提取
      const str = this.listArr[num - 1]
      financeBadDebtA(this.fbdIds, num === 3 ? 1 : 2, str).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(num === 3 ? '提取成功！' : '认领成功！')
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onExtract (row) {
      this.$router.push({
        name: 'baddetails',
        query: { id: row.id }
      })
    },
    onSearch (arr) {
      this.pageSize = 30
      this.currentPage = 1
      this.columnArr = arr
      this.getList()
    },
    // 列表数据
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.columnArr,
        queryPageName: ''
      }
      queryFinanceBadDebtListByState(
        this.activeName,
        this.currentPage,
        this.pageSize,
        params
      ).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          this.list = res.data.obj.records || []
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleSelectionChange (val) {
      this.checkList = val
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // tabs切换时触发的事件 第一tabs
    handleClick (tab) {
      this.currentPage = 1
      if (tab.name === '1') {
        this.columnList = [
          ...badDebte,
          { label: '认领人', value: 'processUser' },
          { label: '认领时间', value: 'processDate' }
        ]
      } else if (tab.name === '2') {
        this.columnList = [
          ...badDebte,
          { label: '认领时间', value: 'processDate' }
        ]
      } else {
        this.columnList = [
          ...badDebte,
          { label: '处理时间', value: 'processDate' }
        ]
      }
      this.$refs.financeSeachRefs.searchReset()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
